import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../../../shared/context/auth-context";
import AtestadosComponent from "./components/AtestadosComponent";
import PrescricoesComponent from "./components/PrescricoesComponent";
import ImpressosComponent from "./components/ImpressosComponent";
import RequisicaoExamesComponent from "./components/RequisicaoExamesComponent";
import ConsentimentosComponent from "./components/ConsentimentosComponent";

function Documentos({
  clienteId,
  sendRequest,
  dadosPrescricao,
  dadosAtestado,
  dadosImpresso,
  dadosRequisicao,
  dadosConsentimento,
  dadosTcle,
}) {
  const temporary = useParams().clienteId;
  const abaAberta = temporary.split("-")[1];
  useEffect(() => {
    if (abaAberta === "impresso" && auth.perm.includes("r-impr"))
      setShowTabs("impressos");
    else if (abaAberta === "prescricao" && auth.perm.includes("r-presc"))
      setShowTabs("prescricao");
    else if (abaAberta === "atestado" && auth.perm.includes("r-ates"))
      setShowTabs("atestado");
    else if (abaAberta === "requisicaoexames") setShowTabs("requisicaoexames");
    /* Sem verificação de permissão, como o das requisições: o separador dos
       consentimentos também não tem nenhuma. Faltava este sufixo — o separador
       existia mas não havia maneira de o abrir por link, e o aviso de documento
       criado aterrava nas prescrições. */
    else if (abaAberta === "consentimento") setShowTabs("consentimentos");
    else setShowTabs("prescricao");
  }, [abaAberta]);

  const [showTabs, setShowTabs] = useState("prescricao");
  const [openAtestadoModal, setOpenAtestadoModal] = useState(false);
  const [openConsentimentoModal, setOpenConsentimentoModal] = useState(false);
  const auth = useContext(AuthContext);

  const handleCloseModalAtestado = () => {
    setOpenAtestadoModal(false);
  };

  const handleCloseModalConsentimento = () => {
    setOpenConsentimentoModal(false);
  };

  const navigate = useNavigate();

  return (
    <div className="container-outros caixa">
      <div className="container-outros-tabs">
        {auth.perm.includes("r-pres") && (
          <span
            className={`tab-button ${
              showTabs === "prescricao" && "tab-button--active"
            }`}
            onClick={() => setShowTabs("prescricao")}
          >
            Prescrições
          </span>
        )}
        {auth.perm.includes("r-ates") && (
          <span
            className={`tab-button ${
              showTabs === "atestado" && "tab-button--active"
            }`}
            onClick={() => setShowTabs("atestado")}
          >
            Atestados
          </span>
        )}

        {auth.perm.includes("r-impr") && (
          <span
            className={`tab-button ${
              showTabs === "impressos" && "tab-button--active"
            }`}
            onClick={() => setShowTabs("impressos")}
          >
            Impressos
          </span>
        )}

        {
          <span
            className={`tab-button ${
              showTabs === "requisicaoexames" && "tab-button--active"
            }`}
            onClick={() => setShowTabs("requisicaoexames")}
          >
            Requisições Exames
          </span>
        }

        {
          <span
            className={`tab-button ${
              showTabs === "consentimentos" && "tab-button--active"
            }`}
            onClick={() => setShowTabs("consentimentos")}
          >
            Consentimentos
          </span>
        }
      </div>

      <div className="container-outros-tabs--Container">
        <div className="tabs-container-top">
          {showTabs === "prescricao" &&
            auth.perm.includes("c-pres") &&
            (auth.role === "Médico/Administrador" ||
              auth.role === "Dentista") && (
              <span
                className="tabs-container-top-button"
                onClick={() => navigate(`../../../prescricao/${clienteId}`)}
              >
                Gerar Prescrição
              </span>
            )}

          {showTabs === "atestado" &&
            auth.perm.includes("c-ates") &&
            (auth.role === "Médico/Administrador" ||
              auth.role === "Dentista") && (
              <span
                className="tabs-container-top-button"
                onClick={(e) => setOpenAtestadoModal(true)}
              >
                Gerar Atestado
              </span>
            )}

          {showTabs === "impressos" &&
            auth.perm.includes("c-impr") &&
            (auth.role === "Médico/Administrador" ||
              auth.role === "Dentista") && (
              <span
                className="tabs-container-top-button"
                onClick={() => navigate(`../../../impresso/${clienteId}`)}
              >
                Gerar Impresso
              </span>
            )}

          {showTabs === "requisicaoexames" &&
            (auth.role === "Médico/Administrador" ||
              auth.role === "Dentista") && (
              <span
                className="tabs-container-top-button"
                onClick={() =>
                  navigate(`../../../requisicaoexames/${clienteId}`)
                }
              >
                Gerar Requisição Exames
              </span>
            )}

          {showTabs === "consentimentos" && (
            <span
              className="tabs-container-top-button"
              onClick={() => setOpenConsentimentoModal(true)}
            >
              Gerar Consentimento de Comunicação
            </span>
          )}
        </div>

        <div className="tabs-container-content">
          {showTabs === "prescricao" && auth.perm.includes("r-pres") && (
            <PrescricoesComponent
              dadosPrescricao={dadosPrescricao}
              clienteId={clienteId}
              sendRequest={sendRequest}
              token={auth.token}
            />
          )}
          {showTabs === "atestado" && auth.perm.includes("r-ates") && (
            <AtestadosComponent
              clienteId={clienteId}
              sendRequest={sendRequest}
              open={openAtestadoModal}
              handleCloseModalAtestado={handleCloseModalAtestado}
              dadosAtestado={dadosAtestado}
            />
          )}

          {showTabs === "impressos" && auth.perm.includes("r-impr") && (
            <ImpressosComponent
              clienteId={clienteId}
              sendRequest={sendRequest}
              dadosImpresso={dadosImpresso}
              token={auth.token}
            />
          )}

          {showTabs === "requisicaoexames" && (
            <RequisicaoExamesComponent
              clienteId={clienteId}
              sendRequest={sendRequest}
              dadosRequisicao={dadosRequisicao}
              token={auth.token}
            />
          )}

          {showTabs === "consentimentos" && (
            <ConsentimentosComponent
              clienteId={clienteId}
              sendRequest={sendRequest}
              dadosConsentimento={dadosConsentimento}
              dadosTcle={dadosTcle}
              open={openConsentimentoModal}
              handleCloseModal={handleCloseModalConsentimento}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Documentos;
